import "./Loader.css"

const Loader = () => {
  return (
    <div className="Loader">
      <div className="loader"></div>
    </div>
  )
}

export default Loader
